import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Chip, Text } from '@frontend/design-system';
import { useContactHistory } from '../providers';

/**
 * `HistoryFilters` component displays a list of active filters as removable chips.
 * It allows users to remove individual filters or clear all filters.
 */
export const HistoryFilters = () => {
  const { t } = useTranslation('contacts');
  const { filters, removeFilter } = useContactHistory();

  if (filters.length === 0) return null;

  return (
    <div css={styles.wrapper}>
      <Text size='small' css={styles.filterLabel}>
        {t('Filters')}
      </Text>
      {filters.map((filter) => (
        <Chip.Removable
          css={styles.removableChip}
          key={`${filter.scope}-${filter.filterType}-${filter.key}`}
          onClick={() => removeFilter(filter)}
          variant='interactive'
        >
          {filter.label}
        </Chip.Removable>
      ))}
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2)};
    align-items: center;
    border-bottom: 1px solid ${theme.colors.neutral20};
    background-color: ${theme.colors.white};
  `,
  filterLabel: css`
    font-color: ${theme.colors.neutral70};
  `,
  removableChip: css`
    color: ${theme.colors.white};
    background-color: ${theme.colors.primary50};
    svg {
      color: ${theme.colors.white};
    }
  `,
};
